import { captureException } from '@sentry/react';
import { types } from 'mobx-state-tree';

import { autoFlow } from '@/stores/storeUtils';
import { authorizedApi } from '@/utils/apiUtils';

export const WedissimoUser = types.model('WedissimoUser', {
  id: types.maybeNull(types.union(types.number, types.string)),
  firstName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  profilePicUrl: types.maybeNull(types.string),
  icsUrl: types.maybeNull(types.string),
  mobile: types.maybeNull(types.string),
  password: types.maybeNull(types.string),
});

const AddWedissimoUserModalStore = types
  .model('AddWedissimoUserModalStore', {
    isOpen: types.boolean,
    isSubmitting: types.boolean,
    newUser: types.maybeNull(WedissimoUser),
    error: types.model({
      message: types.string,
    }),
  })
  .actions((self) =>
    autoFlow({
      toggle() {
        self.isOpen = !self.isOpen;
      },

      open() {
        self.isOpen = true;
      },

      close() {
        self.isOpen = false;
      },

      *onSubmit({ profile }) {
        self.isSubmitting = true;
        self.error.message = '';

        console.log('onSubmit called');

        try {
          const response = yield authorizedApi.post(
            `/business/test/${profile.businessId}/generate-users`,
            {
              users: [self.newUser],
              appointmentTypeId: 6134,
            },
          );

          const { data } = response ?? {};

          console.log('onSubmit data: ', data);

          if (data?.seats?.length) {
            const convertedUserToUserSeat = data.seats.map((item) => {
              const { user, status, email, id, type } = item;

              return transformUserToUserSeat({
                seatId: id,
                user,
                status,
                email,
                type,
              });
            });

            self.userSeats = convertedUserToUserSeat.filter((item) => !!item);
          }
        } catch (error) {
          if (!error?.response) {
            captureException(error);
          }
        }

        self.isSubmitting = false;
      },

      setNewUser(userDetails) {
        self.newUser = userDetails;
      },

      setError(message) {
        self.error.message = message;
      },
    }),
  );

const addWedissimoUserModalStore = AddWedissimoUserModalStore.create({
  isOpen: false,
  isSubmitting: false,
  newUser: {},
  error: {
    message: '',
  },
});

export default addWedissimoUserModalStore;
